import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { RegionVariantService } from 'app/core/region-variant/region-variant.service';
import { AdminType } from 'app/model';

@Component({
  selector: 'insol-select-job-type',
  templateUrl: './select-job-type-form-field.component.html',
})
export class SelectJobTypeFormFieldComponent {
  @Input() appearance: string;
  @Input() jobTypes: AdminType[];
  @Input() disabled: boolean;

  @Input() allowClear: boolean = true;

  @Input() selectedJobTypeId: number;
  @Output() selectedJobTypeIdChange = new EventEmitter<number>();

  constructor(public regionVariantService: RegionVariantService) {}

  select(event: MatSelectChange): void {
    this.selectedJobTypeIdChange.next(event.value);
  }

  clear(event: PointerEvent) {
    if (this.allowClear) {
      this.selectedJobTypeIdChange.next(null);
      event.stopPropagation();
    }
  }
}
